import { useParams } from "react-router-dom";
import VideoPlayer from "../components/VideoPlayer";
import { useEffect, useState } from "react";

export default function Movie() {
  const { mov } = useParams();
  const [link, setLink] = useState('https://nataliabarrera.com/media/videos/Peli_Bathos.mp4')

  useEffect(() => {
    if (mov) {
      setLink('https://nataliabarrera.com/media/videos/Bathos_Inicia.mp4')
    } else {
      setLink('https://nataliabarrera.com/media/videos/Peli_Bathos.mp4')
    }
  }, [mov]);
  
  return (
    <VideoPlayer url={link} muted={false} />
  );
}